export default __webpack_public_path__ + "static/media/mainpfp.b59c591f.jpg";